module.exports = __webpack_public_path__ + "img/one-time-green.b6fc1c39.svg";